import styled from 'styled-components';
import { FOCUS_OUTLINE_STYLE, getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/common';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
import { Stack } from '../Stack';

export const PageText = styled.div`
    ${getTextTokenPreset('bodyLargeStrong')};
`;

export const OverflowedContainer = styled.div`
    ${getTextTokenPreset('bodyLargeStrong')};
    text-align: center;
    min-width: ${getSpacingToken('400')}px;
`;

export const GhostIconButton = styled(IconButton)`
    background-color: transparent;
    color: ${getToken('textStaticPrimary')};

    &:focus-visible {
        ${FOCUS_OUTLINE_STYLE}
    }

    &:disabled {
        background-color: transparent;
        color: ${getToken('textDisabled')};
    }

    &:hover:not([disabled]) {
        background-color: ${getToken('backgroundInteractiveNeutralSubtleHover')};
    }

    &:active:enabled {
        background-color: ${getToken('backgroundInteractiveNeutralSubtleActive')};
    }
`;

export const SquareButton = styled(Button).attrs({ type: 'submit' })`
    background-color: transparent;
    padding: ${getSpacingToken('0')};
    min-width: 32px;
    margin: ${getSpacingToken('25')}px;
    color: ${getToken('textStaticSecondary')};

    &:focus-visible {
        ${FOCUS_OUTLINE_STYLE}
        background-color: ${getToken('backgroundInteractiveNeutralSubtleHover')};
    }

    &:disabled {
        opacity: ${getToken('opacity1000')};
        color: ${getToken('textStaticPrimary')};
        border: ${getToken('borderWidth150')}px solid ${getToken('backgroundInteractiveNeutralBoldDefault')};
    }

    &:hover:not([disabled]) {
        background-color: ${getToken('backgroundInteractiveNeutralSubtleHover')};
    }

    &:active:enabled {
        background-color: ${getToken('backgroundInteractiveNeutralSubtleActive')};
    }
`;

export const MenuWrapper = styled(Stack)`
    margin: 0;
    padding: 0;
    list-style: none;
`;

SquareButton.defaultProps = {
    variant: 'ghost',
};
